var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17139",
    fill: "none",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2",
    fill: "#185edf"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21460",
    d: "M8.238 4.337A1.038 1.038 0 1 1 7.2 5.375a1.038 1.038 0 0 1 1.038-1.038m0-1.384a2.423 2.423 0 1 0 2.423 2.423 2.423 2.423 0 0 0-2.423-2.423Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21461",
    d: "M8.307.184a5.961 5.961 0 0 0-5.884 6.23c0 3.427 3.98 7.372 5.4 8.791a.658.658 0 0 0 .969 0c1.419-1.419 5.4-5.3 5.4-8.791A5.921 5.921 0 0 0 8.307.184Zm-4.5 6.23a4.578 4.578 0 0 1 4.5-4.846 4.578 4.578 0 0 1 4.5 4.846 7.029 7.029 0 0 1-1.35 3.565 6.629 6.629 0 0 0-6.3 0 7.029 7.029 0 0 1-1.35-3.565Zm4.5 7.338a33.4 33.4 0 0 1-2.319-2.63 5.123 5.123 0 0 1 4.638 0 33.4 33.4 0 0 1-2.319 2.631Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/tickets.c6ec6a4794e05e5ec2dc66ee3804d6d7.svg";
export { ForwardRef as ReactComponent };